import {Component, input, model, output} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-navigation-link-subitem',
    templateUrl: './app-navigation-link-subitem.component.html',
    styleUrls: ['./app-navigation-link-subitem.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive]
})
export class AppNavigationLinkSubitemComponent {
    text = input<string>('');
    link = input<string | null>(null);
    icon = input<string>('');
    disabled = model<boolean>(false);
    navigate = output<void>();

    onClick(): void {
        // Don't do anything if the link is disabled
        if (this.disabled()) {
            return;
        }
        this.navigate.emit();
    }
}
